// extracted by mini-css-extract-plugin
export var inner = "modal-module--inner--0fc9a";
export var outer = "modal-module--outer--79585";
export var root = "modal-module--root--7c7ab";
export var scroll = "modal-module--scroll--1879f";